module.exports = __webpack_public_path__ + "static/media/gold-coast-suns-logo.e2c920ce.svg";